// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VZ4t","image":"Header_image__2dVmU","name":"Header_name__1HTRA","info":"Header_info__2BJLg","infoRow":"Header_infoRow__1V9BS"};